import { useEffect, VFC } from 'react'
import { logPromotionClick } from 'src/api/promotion'
import { RecommendationCardBase } from 'src/components/UserCard'
import { DISPLAY_TYPE, Promotion } from 'src/models/Promotion'
import { RecommendedUser } from 'src/models/User'
import styled from 'styled-components'
import { asModal, ModalProps } from '../hoc/asModal'

type PromotionProps = {
  promotion: Promotion
  showDetail: () => unknown
  showReasonModal: () => unknown
  status: RecommendedUser['matchingStatus']
  displayType?: DISPLAY_TYPE
  prDetail: string
  showProfileModalWithButton?: () => void
  onClickNotInterested: () => void
  isDisplayedProfileButton?: true
}
const PromotionComponent: VFC<ModalProps<PromotionProps>> = ({
  promotion,
  showDetail,
  showReasonModal,
  status,
  displayType,
  prDetail,
  showProfileModalWithButton,
  onClickNotInterested,
  isDisplayedProfileButton,
}) => {
  const { id, token, user } = promotion
  useEffect(() => {
    logPromotionClick({ userId: user.id, id, token })
  }, [])
  return (
    <Layout>
      <RecommendationCardBase
        user={{
          ...user,
          ...(status ? { matchingStatus: status } : {}),
        }}
        showDetail={() => showDetail()}
        showReasonModal={() => showReasonModal()}
        postNotInterested={onClickNotInterested}
        displayType={displayType}
        prDetail={prDetail}
        showProfileModalWithButton={showProfileModalWithButton}
        isDisplayedProfileButton={isDisplayedProfileButton}
      />
    </Layout>
  )
}

const Layout = styled.div`
  width: 100%;
  min-width: max(40vw, 260px);
  max-width: min(80vw, 800px);
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 20px;
`

export const PromotionModal = asModal(PromotionComponent, {
  scrollable: true,
})
